// @flow
import React from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import { scrollToElement } from "Commons/Utilities/scrollTo";
import { FragenBaseRoute } from "modules/ContentPages/misc/ContentPageRoutes";
import { changeServiceProcessRoute } from "modules/ChangeService/Wizard/misc/Routes";
import { Button } from "shared/formElements";
import LightBulb from "flavours/app-remind.me/assets/images/lightbulb.jpg";
import type { OfferT } from "modules/Offers/misc/Types";
import type { ReminderT } from "modules/Reminder/misc/Types";

import { ReactComponent as ArrowRight } from "Commons/Assets/icons/Arrow_right.svg";
import Styles from "./NeedToKnow.module.scss";

type Props = {
  offer: OfferT,
  reminder: ReminderT,
  category: string,
  fullWidth?: boolean,
};

const NeedToKnow = ({ offer, reminder, category, fullWidth }: Props) => {
  const { t } = useTranslation("offerPageDetail");

  return (
    <div className={Styles.needToKnow} style={{ backgroundImage: `url(${LightBulb})` }}>
      <div className={Styles.widthLimit}>
        <div className={classnames(Styles.responsiveContent, { [Styles.fullWidth]: fullWidth })}>
          <h3>{t("needToKnow.title")}</h3>
          <p>{t("needToKnow.description")}</p>
          <br />
          <div className={Styles.ctaButtons}>
            <HashLink to="#CSF" scroll={(el) => scrollToElement(el, "smooth", -80)}>
              <Button>{t("changeServiceCTA")}</Button>
            </HashLink>
            <Link to={FragenBaseRoute + changeServiceProcessRoute}>
              <Button secondary>
                {t("needToKnow.faqLink")}
                <ArrowRight />
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NeedToKnow;
